import React from 'react';
import {sidePaddingNormal, verticalPaddingNormal} from "../styles/layouts";
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';


const styles = (theme) => ({
  container: {
    padding: '4em 2em',
    [theme.breakpoints.up('md')]: {
      padding: '12em 6em',
    },
  },
  smallContainer: {
    padding: '3em 2em',
    [theme.breakpoints.up('md')]: {
      padding: '7em 6em',
    }
  },
  noSides: {
    paddingLeft: 0,
    paddingRight: 0,
  },
});


function Section(props) {
  const {classes, className, small, side = true} = props;

  return (
    <section className={classNames({
        [classes.noSides]: !side
      },
      (small) ? classes.smallContainer : classes.container,
      className)}>
      {props.children}
    </section>
  )
}

export default withStyles(styles)(Section);




// WEBPACK FOOTER //
// ./src/parts/Section.js